import React from "react";
import TailwindFlex from "library/components/_tailwind/flex";
import TailwindIcon from "library/components/_tailwind/icon";
import { CustomIconName } from "library/components/_tailwind/icon/icons/enums";
import TailwindTranslatedText from "library/components/_tailwind/translated-text";

const MessageCenterPendingVideoReview: React.FC = () => {
  return (
    <TailwindFlex
      className={["MessageCenterPendingVideoReview"]}
      flexDirection='flex-col'
      alignItems='items-center'
      textAlign='text-center'
      gap={"gap-1"}>
      <TailwindIcon
        name={CustomIconName["video-camera"]}
        fontSize='text-2xl'
      />
      <TailwindTranslatedText
        fontSize='text-sm'
        fontWeight='font-bold'
        descriptor={{
          id: "message-center.video-pending-review",
          defaultMessage: "Video message pending review",
        }}
      />
      <TailwindTranslatedText
        fontSize='text-xs'
        textColor='text-gray-500'
        descriptor={{
          id: "message-center.video-pending-review-description",
          defaultMessage: "You'll see it once it's approved",
        }}
      />
    </TailwindFlex>
  );
};

export default MessageCenterPendingVideoReview;
